<template>
  <section class="interactive">
    <div
      class="interactive__artwork"
      :style="`/* background-image:url('${artwork.url}') */`">
      <img :src="artwork.url" />
    </div>
    <ul
      class="interactive__list"
      :style="`height: ${height}px`">
      <li
        v-for="(note, key) in items"
        :key="key"
        class="item"
        :class="{'item--active': key === active}"
        :data-key="key">
          <div
            class="item__image">
            <div
              v-if="note.active"
              class="info"
              :style="`left: ${getX(note.position.x)}%; top: ${note.position.y}%;`">
              <p
                class="note"
                v-html="note.description"></p>
            </div>
            <img :src="note.image.url" />
            <button
              @mouseenter="active = key, toggleInfo(note, true)"
              @mouseleave="active = null, toggleInfo(note, false)"
              :style="`left: ${note.position.x}%; top: ${note.position.y}%;`">
              </button>
          </div>
        </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'InteractiveBlock',
  props: {
    highlights: {
      type: Array,
      default: null
    },
    artwork: {
      type: Object,
      default: null
    },
    ratio: {
      type: [ Number, String ],
      default: 1
    }
  },
  data() {
    return {
      active: null,
      highlightActive: null,
      height: 400,
      resize: false
    }
  },
  computed: {
    items: function() {
      return this.highlights.map(highlight => {
        highlight.active = false
        return highlight
      })
    }
  },
  mounted() {
    // set artwork height on load
    this.height = this.getHeight()

    window.addEventListener('resize', () => {
      clearTimeout(this.resize)

      this.resize = window.setTimeout(() => {
        this.height = this.getHeight()
      }, 200)
    })
  },
  methods: {
    getX(value) {
      const width = document.querySelector('interactive')

      const x = width > 1024 ? value : (value > 50 ? value - (value / 4) : value)

      return x
    },
    updateActive($evt) {
      const key = $evt.target.getAttribute('data-key')

      // update active
      this.active = key
    },
    getHeight() {
      const interactiveWidth = document.querySelector('.interactive')

      const width = interactiveWidth.clientWidth < 900 ? interactiveWidth.clientWidth : 900

      console.log(interactiveWidth)

      console.log(width)
      console.log(this.ratio)

      return `${width * parseFloat(this.ratio)}`
    },
    toggleInfo(note, state) {
      note.active = state
    }
  }
}
</script>

<style lang="scss" scoped>
.interactive {
  position:relative;

  &__artwork {
    // text-align: center;
    display: flex;
    justify-content: center;

    img {
      max-width: 900px;
      // object-fit: contain;
    }
  }

  &__list {
    position: absolute;
    width:100%;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: center;

    .item {
      position: absolute;
      display:inline-block;
      margin:0 auto;
      width:100%;
      height:100%;

      &__image {
        width:100%;
        height:100%;
        position: relative;
        display: flex;
        justify-content: center;

        img {
          margin: 0 auto;
          opacity: 0;
          transition: opacity 200ms ease-in-out;
          object-fit: contain;
          max-width: 900px;
        }

        .info {
          position: absolute;
          transform: translate(-50%, calc(-100% - 25px));
          width: 400px;
          max-width: 65vw;
          padding: $page-padding;
          background-color: $background;
          border-radius: 1rem;
          border: 1px solid #000;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
          z-index: 2;
        }
      }

      &--active {
        .item__image {
          img {
            opacity:1;
          }
        }
      }

      button {
        background-color:#000;
        position:absolute;
        width: 20px;
        height: 20px;
        padding: 0px;
        border-radius: 20px;
        transition: all 200ms ease;
        transform:translate(-50%, -50%);
        z-index:1;

        &--active, &:hover {
          width:32px;
          height:32px;
          border-radius:34px;
        }
      }
    }
  }

  @include mobile {
    &__artwork {
      img {
        max-width: 100%;
      }
    }
    &__list {
      .item {
        &__image {
          .info {
            transform: translate(calc(-50%), calc(-100% - 18px));
            padding: $page-padding;
          }
          img {
            max-width: 100% !important;
            object-fit: unset;
          }
        }
        button {
          width: 14px;
          height: 14px;

          &--active, &:hover {
            width:20px;
            height:20px;
          }
        }
      }
    }
  }
}
</style>
